import { connect } from 'react-redux';
import { State } from 'store/state';
import { isAfterLisingDeleteModalOpenSelector } from 'store/state/app/selectors';
import { AfterDeleteListingModalBase } from './AfterDeleteListingModal';
import { setAfterListingDeleteModalOpen } from 'store/state/app/actions';


const mapStateToProps = (state: State) => ({
  isOpen: isAfterLisingDeleteModalOpenSelector(state),
});

const mapDispatchToProps = {
  setOpen: setAfterListingDeleteModalOpen,
};

export const AfterDeleteListingModal = connect(mapStateToProps, mapDispatchToProps)(AfterDeleteListingModalBase);
